// import ApprovalScope from "./ApprovalScope";
// import Footer from "../components/Footer";
// export default function Liaisoning({openContactModal, showCTA}) {
//   return (
//     <div>

    
//       <ApprovalScope />



//     </div>
//   );
// }

import React from "react";
import ApprovalScope from "./ApprovalScope";
import Footer from "../components/Footer";

// images
// import img1 from "../image/approval1.webp";
// import img2 from "../image/sanction-img.avif";
// import img3 from "../image/approval3.jpg";
// import img4 from "../image/authority-img.jpg";
// import img5 from "../image/approval5.jfif";
// import img6 from "../image/plinth.jpg";
// import img7 from "../image/approval7.jpg";
import hero2 from "../image/corporation-bg2.png";
import hero7 from "../image/corporation-bg2.png";
import {
  FaSearch,
  FaDraftingCompass,
  FaFileAlt,
  FaHandshake,
  FaCheckCircle,
  FaRulerCombined,
  FaCertificate
} from "react-icons/fa";

// const liaisonData = [
//   {
//     id: "01",
//     title: "Authority Consultation",
//     desc: "Understanding requirements from local authorities and departments.",
//     img: img1,
//   },
//   {
//     id: "02",
//     title: "Document Coordination",
//     desc: "Managing all necessary documents for approvals and submissions.",
//     img: img2,
//   },
//   {
//     id: "03",
//     title: "Application Filing",
//     desc: "Submitting applications to concerned authorities properly.",
//     img: img3,
//   },
//   {
//     id: "04",
//     title: "Follow-ups",
//     desc: "Continuous follow-ups to avoid delays in approvals.",
//     img: img4,
//   },
//   {
//     id: "05",
//     title: "Issue Resolution",
//     desc: "Handling objections or queries raised by authorities.",
//     img: img5,
//   },
//   {
//     id: "06",
//     title: "Inspection Coordination",
//     desc: "Managing site inspections with officials.",
//     img: img6,
//   },
//   {
//     id: "07",
//     title: "Final Clearance",
//     desc: "Ensuring all permissions are received smoothly.",
//     img: img7,
//   },
// ];


const liaisonData = [
  {
    id: "01",
    icon: <FaSearch />,
    title: "Regulatory Feasibility Assessment",
    desc: "Evaluation of zoning regulations, setbacks, FSI potential, and applicable development rules for your plot.",
  },
  {
    id: "02",
    icon: <FaDraftingCompass />,
    title: "Sanction Drawings Preparation",
    desc: "Preparation of approval drawings compliant with Municipal Corporation and PMRDA norms.",
  },
  {
    id: "03",
    icon: <FaFileAlt />,
    title: "Documentation & Application Submission",
    desc: "Preparation and filing of all technical documents, forms, and statutory approval packages.",
  },
  {
    id: "04",
    icon: <FaHandshake />,
    title: "Authority Coordination & Follow-up",
    desc: "Liaison and follow-ups with departments during scrutiny and approval processing stages.",
  },
  {
    id: "05",
    icon: <FaCheckCircle />,
    title: "Final Sanction & Permission Closure",
    desc: "Approval acquisition and permission enabling construction start.",
  },
  {
    id: "06",
    icon: <FaRulerCombined />,
    title: "Plinth Check Certificate",
    desc: "Authority inspection coordination after plinth completion and obtaining the Plinth Check Certificate.",
  },
  {
    id: "07",
    icon: <FaCertificate />,
    title: "Completion Certificate",
    desc: "Final authority inspection and securing Completion Certificate after construction completion.",
  },
];

export default function Liaisoning({ openContactModal, showCTA }) {
  return (
    <div>
  
      <ApprovalScope 
        heroTitle={`Building Approvals from Municipal Corporations & PMRDA`}
        heroSubtitle=" Regulatory permissions managed seamlessly for your bungalow project."
          heroImg={hero2}
           heroBg={hero7}


        topText=" We manage building approvals from initial feasibility to final Completion Certificate —
    ensuring your project complies with all statutory development regulations."

        heading="Detailed Approval Scope"

        data={liaisonData}

        ctaTitle="Dwellora Approval Approach"
        ctaDesc=" Our familiarity with regulatory procedures minimizes delays and uncertainties. 
           By integrating approvals with design planning, we ensure your project progresses 
           legally, efficiently and without procedural stress."
        // ctaBtn="Get Expert Assistance"
        ctaBtn="Let’s Consult"
  openContactModal={openContactModal}

      />

      {/* Footer */}
      <Footer 
        openContactModal={openContactModal}
        showCTA={showCTA} 
      />

    </div>
  );
}

